<div
  class="w-full border-b flex justify-between px-[15px] py-[10px] max-h-[70px] h-full"
>
  <div class="w-fit h-full flex gap-[10px] items-center">
    <img
      (click)="mobileSideNavOpen()"
      class="w-[22px] h-[22px] flex sm:hidden cursor-pointer"
      src="../../../assets/icons/hamburger.svg"
      alt=""
    />
    <span class="capitalize text-[20px] sm:text-[24px] font-[800]">{{
      currentRoute
    }}</span>
  </div>
  <div class="flex w-fit gap-[10px] items-center">
    <div
      (click)="openNav()"
      class="flex cursor-pointer gap-[10px] items-center justify-end"
    >
    <div class="w-full h-[full]"><app-avatar [size]="'50'" [text]="details?.name" /></div>
     <div class="flex cursor-pointer flex-col gap-[0px] sm:gap-[5px]">
      <span *ngIf="!fetchingData" class="text-[14px] sm:text-[18px] font-[700]">{{
        details?.name
      }}</span>
      <div *ngIf="fetchingData" class="w-[120px] h-[25px] bg-slate-100 rounded-[3px] animate-pulse"></div>
      <div *ngIf="fetchingData" class="w-[120px] h-[15px] bg-slate-100 rounded-[3px] animate-pulse"></div>
      <span class="text-[10px] text-gray-400 font-[500]">{{
        details?.emailAddress
      }}</span>
     </div>
    </div>
    <div class="relative">
      <img
        class="cursor-pointer"
        (click)="openNav()"
        src="../../../assets/icons/chevron.svg"
        alt=""
      />
      <div
        *ngIf="navOpen"
        class="absolute top-[40px] right-0 z-[1000] bg-[#fff] rounded-[8px] shadow-md w-[250px] p-[15px] flex gap-[20px] flex-col"
      >
        <div class="flex flex-col w-full gap-[10px]">
          <div
            class="w-full flex flex-col justify-center items-center gap-[8px]"
          >
            <app-avatar [size]="'45'" [text]="activeBusiness?.name" />
            <span>{{ activeBusiness?.name }}</span>
          </div>
         <app-button [label]="'New Business'"
         (onClick)="addBusiness()"
         [className]="
           'text-[#081A46] w-full h-[35px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[50px] border border-[#081A46] bg-[#fff]'
         " />
          <div
            class="flex flex-col bg-slate-50 rounded-[5px] gap-[10px] w-full"
          >
            <div
              *ngFor="let business of businesses"
              (click)="switchBusiness(business?._id)"
              class="w-full flex items-center gap-[15px] p-[8px] cursor-pointer rounded-[5px] hover:bg-slate-100"
            >
            <app-avatar [size]="'45'" [text]="business?.business?.name" />
              <span>{{ business?.business?.name }}</span>
            </div>
          </div>
        </div>
        <div (click)="logout()"
          class="w-full bg-slate-100 rounded-[5px] cursor-pointer py-[10px] flex justify-center items-center"
        >
          <span class="font-[700] text-[14px] text-slate-800">Logout</span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal
  [title]="'Add New Business'"
  [isOpen]="newBusinessModalOpen"
  (closeModalEvent)="closeNewBusinessModal()"
>
  <div class="flex flex-col w-full gap-[20px] items-center">
    <div class="w-full flex flex-col">
      <app-input
        [label]="'Business Name'"
        [placeholder]="'Enter business name'"
        [title]="'name'"
        [error]="errors.name"
        (returnValue)="handleInput($event)"
      />
      <app-input
        [label]="'Email Address'"
        [placeholder]="'Enter email address'"
        [title]="'emailAddress'"
        (returnValue)="setEmail($event)"
        [error]="errors.emailAddress"
      />
      <app-input
        [label]="'Business Address'"
        [placeholder]="'Enter business address'"
        [title]="'address'"
        (returnValue)="handleInput($event)"
        [error]="errors.address"
      />
      <div class="w-full grid grid-cols-2 gap-[20px]">
        <app-input
          [label]="'City'"
          [placeholder]="'Enter city'"
          [title]="'city'"
          (returnValue)="handleInput($event)"
          [error]="errors.city"
        />
        <app-input
        [label]="'State'"
        [placeholder]="'Enter state'"
        [title]="'state'"
        (returnValue)="handleInput($event)"
        [error]="errors.state"
      />
      </div>
      <div class="w-full grid grid-cols-2 gap-[20px]">
        <app-input
          [label]="'Country'"
          [placeholder]="'Enter state'"
          [title]="'country'"
          (returnValue)="handleInput($event)"
          [error]="errors.country"
        />
        <app-input
          [label]="'Postal Code'"
          [placeholder]="'Enter postal code'"
          [title]="'postalCode'"
          (returnValue)="handleInput($event)"
          [error]="errors.postalCode"
        />
      </div>
      <app-text-area
        [label]="'Business Description'"
        [placeholder]="'Enter business description'"
        [title]="'description'"
        (returnValue)="handleInput($event)"
        [error]="errors.description"
      />
    </div>
    <app-button
      [label]="'Add Business'"
      (onClick)="addBusiness()"
      [loading]="loading"
      [className]="
        'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
      "
    ></app-button>
  </div>
</app-modal>
